import React, { useState, useEffect } from 'react';
import api from '../services/api';

function UserManagement() {
  const [users, setUsers] = useState([]);
  const [xaPhuongList, setXaPhuongList] = useState([]);
  const [newUser, setNewUser] = useState({ username: '', role: 'tinh', xa_id: '' });
  const [newXa, setNewXa] = useState('');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  // Tải danh sách user và xã khi component được render
  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    setLoading(true);
    try {
      // (Giữ nguyên) Tải cả 2 danh sách
      const [usersRes, xaRes] = await Promise.all([
        api.get('/users'),
        api.get('/data/xaphuong')
      ]);
      setUsers(usersRes.data);
      setXaPhuongList(xaRes.data);
      setLoading(false);
    } catch (err) {
      console.error(err);
      setError('Không thể tải dữ liệu');
      setLoading(false);
    }
  };

  // (Giữ nguyên)
  const handleAddXa = async (e) => {
    e.preventDefault();
    if (!newXa) return;
    try {
      await api.post('/data/xaphuong', { ten_xa: newXa });
      setNewXa('');
      fetchData(); // Tải lại danh sách
    } catch (err) {
      console.error(err);
      alert('Lỗi: ' + (err.response?.data?.message || 'Không thể thêm xã'));
    }
  };
  
  // (MỚI - Điểm 4) Xử lý Khóa/Mở khóa xã
  const handleToggleLock = async (xaId, currentStatus) => {
    const action = currentStatus ? "MỞ KHÓA" : "KHÓA";
    if (window.confirm(`Bạn có chắc muốn ${action} xã này? User Xã sẽ ${action === 'KHÓA' ? 'không thể' : 'có thể'} chỉnh sửa dữ liệu.`)) {
      try {
        await api.put(`/data/xaphuong/${xaId}/toggle-lock`);
        fetchData(); // Tải lại danh sách để cập nhật trạng thái
      } catch (err) {
        console.error(err);
        alert(`Lỗi: Không thể ${action} xã`);
      }
    }
  };

  // (Giữ nguyên)
  const handleCreateUser = async (e) => {
    e.preventDefault();
    try {
      await api.post('/users', newUser);
      setNewUser({ username: '', role: 'tinh', xa_id: '' });
      fetchData(); // Tải lại danh sách
    } catch (err) {
      console.error(err);
      alert('Lỗi: ' + (err.response?.data?.message || 'Không thể tạo user'));
    }
  };

  // (Giữ nguyên)
  const handleResetPassword = async (userId, username) => {
    if (window.confirm(`Bạn có chắc muốn reset mật khẩu cho ${username} về 'Na@123'?`)) {
      try {
        await api.put(`/users/${userId}/reset-password`);
        alert('Reset mật khẩu thành công!');
      } catch (err) {
        console.error(err);
        alert('Lỗi: Không thể reset mật khẩu');
      }
    }
  };

  if (loading) return <p>Đang tải dữ liệu...</p>;
  if (error) return <p style={{ color: 'red' }}>{error}</p>;

  return (
    <div style={{ padding: '20px', display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '20px' }}>
      
      {/* CỘT 1: QUẢN LÝ XÃ */}
      <div>
        <h2>Quản lý Xã/Phường</h2>
        <form onSubmit={handleAddXa}>
          <input 
            type="text"
            value={newXa}
            onChange={(e) => setNewXa(e.target.value)}
            placeholder="Thêm xã/phường mới (ví dụ: An Tảo)"
          />
          <button type="submit">Thêm xã</button>
        </form>

        {/* (MỚI) Bảng danh sách xã */}
        <h3 style={{marginTop: '20px'}}>Danh sách Xã/Phường ({xaPhuongList.length})</h3>
        <table style={{ width: '100%', borderCollapse: 'collapse' }}>
          <thead>
            <tr style={{ background: '#ddd' }}>
              <th style={{ padding: '8px', border: '1px solid #ccc' }}>Tên Xã</th>
              <th style={{ padding: '8px', border: '1px solid #ccc' }}>Trạng thái</th>
              <th style={{ padding: '8px', border: '1px solid #ccc' }}>Hành động</th>
            </tr>
          </thead>
          <tbody>
            {xaPhuongList.map(xa => (
              <tr key={xa.id}>
                <td style={{ padding: '8px', border: '1px solid #ccc' }}>{xa.ten_xa}</td>
                <td style={{ padding: '8px', border: '1px solid #ccc', color: xa.is_locked ? 'red' : 'green', fontWeight: 'bold' }}>
                  {xa.is_locked ? 'Đã Khóa' : 'Đang Mở'}
                </td>
                <td style={{ padding: '8px', border: '1px solid #ccc', textAlign: 'center' }}>
                  <button 
                    onClick={() => handleToggleLock(xa.id, xa.is_locked)}
                    style={{ background: xa.is_locked ? 'green' : 'red', color: 'white' }}
                  >
                    {xa.is_locked ? 'Mở Khóa' : 'Khóa'}
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* CỘT 2: QUẢN LÝ TÀI KHOẢN */}
      <div>
        <h2>Quản lý Tài khoản</h2>
        <form onSubmit={handleCreateUser} style={{ background: '#f4f4f4', padding: '15px', borderRadius: '8px' }}>
          <h3>Tạo tài khoản mới</h3>
          <input 
            type="text"
            placeholder="Tên đăng nhập"
            value={newUser.username}
            onChange={(e) => setNewUser({...newUser, username: e.target.value})}
            required
          />
          <select 
            value={newUser.role}
            onChange={(e) => setNewUser({...newUser, role: e.target.value, xa_id: ''})}
          >
            <option value="tinh">User Tỉnh</option>
            <option value="xa">User Xã</option>
          </select>
          
          {newUser.role === 'xa' && (
            <select 
              value={newUser.xa_id}
              onChange={(e) => setNewUser({...newUser, xa_id: e.target.value})}
              required
            >
              <option value="">-- Chọn xã --</option>
              {xaPhuongList.map(xa => (
                <option key={xa.id} value={xa.id}>{xa.ten_xa}</option>
              ))}
            </select>
          )}
          <button type="submit">Tạo User</button>
        </form>

        <h3 style={{marginTop: '20px'}}>Danh sách tài khoản ({users.length})</h3>
        <table style={{ width: '100%', borderCollapse: 'collapse' }}>
          <thead>
            <tr style={{ background: '#ddd' }}>
              <th style={{ padding: '8px', border: '1px solid #ccc' }}>Tên đăng nhập</th>
              <th style={{ padding: '8px', border: '1px solid #ccc' }}>Quyền</th>
              <th style={{ padding: '8px', border: '1px solid #ccc' }}>Đơn vị (Xã)</th>
              <th style={{ padding: '8px', border: '1px solid #ccc' }}>Hành động</th>
            </tr>
          </thead>
          <tbody>
            {users.map(user => (
              <tr key={user.id}>
                <td style={{ padding: '8px', border: '1px solid #ccc' }}>{user.username}</td>
                <td style={{ padding: '8px', border: '1px solid #ccc' }}>{user.role}</td>
                <td style={{ padding: '8px', border: '1px solid #ccc' }}>{user.ten_xa || 'N/A'}</td>
                <td style={{ padding: '8px', border: '1px solid #ccc', textAlign: 'center' }}>
                  <button 
                    onClick={() => handleResetPassword(user.id, user.username)}
                    style={{ background: 'orange', color: 'white' }}
                  >
                    Reset Mật khẩu
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default UserManagement;
